module.exports = __webpack_public_path__ + "img/a2_2.48313e31.png";